module.exports = __webpack_public_path__ + "static/media/eraser.85019c25.svg";